import { PROJECT_NAME } from "../../config";
import "./footer.css";

function Footer() {
  return (
    <div className="bg-black text-white text-center py-2 h-10 fixed bottom-0 left-0 right-0 z-20">
      <small>{PROJECT_NAME} Dashboard</small>
    </div>
  );
}

export default Footer;
